export default lang => {
  return {
    // harcoded config values
    TOGGLE_LANG: lang == "es" ? "In English" : "En Español",
    ABOUT_FOOTER: lang == "es" ? "Nosotros" : "About Us",
    SERIES_FOOTER: "Videos",
    FREE_VIDEOS: lang == "es" ? "Videos Gratis" : "Free Videos",
    P_CANCELAR: lang == "es" ? "Cancela cuando quieras" : "Cancel anytime",
    SUBSCRIBE: lang == "es" ? "Suscribirme por" : "Subscribe for",
    PAY_TODAY:
      lang == "es"
        ? "Monto a pagar hoy $0.00"
        : "Amount to pay today $0.00",
    PROCESS_REGISTRATION: lang == "es" ? "Registrarme" : "Register",
    CONFIGURE_PAYMENT_FOR_LATER:
      lang == "es"
        ? "Configurar pago para mas tarde"
        : "Configure payment for later",
    NO_CHARGE_UNTIL: lang == "es" ? "Sin cargo hasta" : "No charge until",
    AMOUNT_AFTER_TRIAL:
      lang == "es"
        ? "Monto a pagar despues de 7 dias prueba"
        : "Amount to pay after 7 days trial",
    COMING_SOON: lang == "es" ? "¡Disponible pronto!" : "Coming Soon!",
    CHANGE_PLAN: lang == "es" ? "Cambiar el plan" : "Change plan",
    WATCH_EPISODES: lang == "es" ? "Ver episodios" : "Watch episodes",
    WATCH_TRAILER: lang == "es" ? "Ver trailer" : "Watch trailer",
    SAVING_PREFERENCES:
      lang == "es" ? "Guardando preferencias" : "Saving preferences",
    YOU_DID_IT: lang == "es" ? "¡Lo lograste!" : "You did it!",
    CONTACT_SUPPORT:
      lang == "es"
        ? "Por favor contacte con atención al cliente"
        : "Please contact customer support",
    CONFIRM_SUBSCRIPTION_CANCELATION:
      lang == "es"
        ? "¿Esta seguro de que desea cancelar su subscripción?"
        : "Are you sure that you want to cancel your subscription?",
    PROMOCODE_VALIDATED:
      lang == "es"
        ? "El código promocional ha sido verificado"
        : "The promocode has been verified",
    APPLY: lang == "es" ? "Aplicar" : "Apply",
    APPLY_PROMOCODE:
      lang == "es" ? "Aplicar código promocional" : "Apply promo code",
    APPLYING_PROMOCODE:
      lang == "es"
        ? "Aplicando código promocional"
        : "Applying promo code",
    APPLIED_PROMOCODE:
      lang == "es" ? "Código promocional aplicado" : "Promocode applied",

    REGION_NOT_AVAILABLE_MESSAGE:
      lang == "es"
        ? "En estos momentos nuestro servicio no esta disponible en tu país.<br><br>Esperamos estar con ustedes pronto. Por favor déjenos su email para notificarle cuando estemos disponible!"
        : "At this time our service is not available in your country. <br> <br> We hope to be with you soon. Please leave us your email to notify you when we are available!",

    RESET_PASSWORD:
      lang == "es" ? "Recuperar Contraseña" : "Reset Password",

    YEARS: lang == "es" ? "años" : "years",

    HOME_TITLE: lang === 'es' ? "¡Dale a tus hijos el mejor de los comienzos!" : "¡Dale a tus hijos el mejor de los comienzos!",
    HOME_FIRST: lang === 'es'
      ? "Las mejores series animadas <br> en un espacio seguro y libre de violencia"
      : "Las mejores series animadas <br> en un espacio seguro y libre de violencia",
    HOME_CTA: lang === 'es' ? 'Comienza ahora' : 'Comienza ahora',
    HOME_SECOND: lang === 'es'
      ? 'Disponible en tu dispositivo favorito'
      : 'Disponible en tu dispositivo favorito',
    HOME_THIRD: lang === 'es'
      ? 'Disfruta de Pinguinitos en tu plataforma favorita, incluyendo teléfonos, tablets y computadoras.'
      : 'Disfruta de Pinguinitos en tu plataforma favorita, incluyendo teléfonos, tablets y computadoras.',
    FOOTER_SLOGAN: lang === 'es'
      ? '¡Descarga la aplicación para divertirte y aprender de forma sana y segura!'
      : '¡Descarga la aplicación para divertirte y aprender de forma sana y segura!',
    FOOTER_ABOUT: lang === 'es'
      ? 'Quiénes Somos' : 'Quiénes Somos',
    FOOTER_CONTACT: lang === 'es'
    ? 'Contacto' : 'Contacto'
  };
};
